<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col>
          <el-image
            src="/images/BUYMeister.png"
            fit="container">
          </el-image>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-input v-model="loginId" placeholder="ログインID" id="login-id"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-input v-model="password" placeholder="パスワード" show-password id="login-password"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-button type="primary" plain @click="authenticate" id="button-login">
          ログイン
        </el-button>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'Login',
  data: function () {
    return {
      loginId: '',
      password: ''
    }
  },
  methods: {
    authenticate: function () {
      var body = {
        loginId: this.loginId,
        password: this.password
      }
      this.$store.dispatch('login', body)
    }
  },
  computed: {
    loginSuccess: function () {
      return (this.$store.state.username != null)
    }
  },
  watch: {
    loginSuccess (newValue) {
      if (newValue) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.el-container {
  margin: 0 auto 0;
  width: 20%;
}
.el-row {
  display: block;
  margin-bottom: 10px;

}
</style>
